import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';

import { SxType } from '@/utils/types';

interface Props {
    rootstyle?: SxType;
    titlestyle?: SxType;
    contentstyle?: SxType;
    width?: string;
    height?: string;
}

export default styled(Dialog)(({ rootstyle, titlestyle, contentstyle, width, height }: Props) => ({
    '& .MuiPaper-root': {
        width,
        height,
        userSelect: 'none',
        maxWidth: 'none',
        borderRadius: '12px',
        ...(rootstyle as any),
    },
    '& .MuiDialogTitle-root': {
        padding: '1rem 2rem',
        display: 'flex',
        alignItems: 'center',
        fontSize: '2rem',
        ...(titlestyle as any),
    },
    '& .MuiDialogContent-root': {
        display: 'flex',
        padding: '0 2rem',
        flexDirection: 'column',
        ...(contentstyle as any),
    },
    '& .MuiDialogActions-root': {
        padding: '1rem 2rem',
        justifyContent: 'center',
    },
    '& .MuiDialogContentText-root': {
        fontSize: '1.6rem',
    },
}));
